import { render, staticRenderFns } from "./side-bar.html?vue&type=template&id=987890e2&scoped=true&"
import script from "./side-bar.js?vue&type=script&lang=js&"
export * from "./side-bar.js?vue&type=script&lang=js&"
import style0 from "./side-bar.scss?vue&type=style&index=0&id=987890e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987890e2",
  null
  
)

export default component.exports